//それぞれmicroCMSのcontentsIdに合わせる。
const CARD_RANKS = {
  NORMAL: { ID: 'normal', LABEL: '一般カード' },
  GOLD: { ID: 'gold', LABEL: 'ゴールドカード' },
  PLATINUM: { ID: 'platinum', LABEL: 'プラチナカード' },
}
module.exports = { CARD_RANKS }
